var map = {
	"./Amazon.png": 31,
	"./BuyMeACoffee.png": 32,
	"./Discord.png": 33,
	"./Instagram.png": 34,
	"./MightyNetworks.png": 35,
	"./OnlyFans.png": 36,
	"./Patreon.png": 37,
	"./Shopify.png": 38,
	"./Substack.png": 39,
	"./TikTok.png": 40,
	"./Twitch.png": 41,
	"./Youtube.png": 42
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30;